<script>
  import { createEventDispatcher } from 'svelte';
  import Login from './Login.svelte';
  import Register from './Register.svelte';
  import { auth } from '../../stores/auth';

  const dispatch = createEventDispatcher();
  let showRegister = false;
  let demoLoading = false;

  function handleSuccess() {
    dispatch('success');
  }

  async function startDemo() {
    demoLoading = true;
    try {
      await auth.demoLogin();
      // Don't navigate here - let parent App.svelte handle navigation via dispatch
      dispatch('success');
    } finally {
      demoLoading = false;
    }
  }
</script>

<div class="auth-layout">
  <!-- Image Side -->
  <aside class="media-side">
    <div class="media-container">
      <img src="/images/ArchxLanding.png" alt="ArchX Platform" class="landing-image" />
    </div>
  </aside>

  <!-- Auth Side -->
  <section class="auth-side">
    <div class="auth-content">
      <!-- Brand -->
      <div class="brand">
        <h1>ArchX</h1>
        <p>Project management for modern teams</p>
      </div>

      <!-- Demo Button -->
      <button class="demo-btn" on:click={startDemo} disabled={demoLoading}>
        {#if demoLoading}
          <span class="spinner"></span>
          Loading...
        {:else}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
            <path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Try Demo
        {/if}
      </button>

      <div class="divider"><span>or sign in</span></div>

      <!-- Auth Form -->
      <div class="form-container">
        {#if showRegister}
          <Register on:success={handleSuccess} />
        {:else}
          <Login on:success={handleSuccess} />
        {/if}
      </div>

      <!-- Toggle -->
      <button class="toggle" on:click={() => showRegister = !showRegister}>
        {showRegister ? 'Already have an account? Sign in' : 'Need an account? Register'}
      </button>

      <p class="terms">
        By continuing, you agree to our Terms of Service.
      </p>
    </div>
  </section>
</div>

<style>
  .auth-layout {
    position: fixed;
    inset: 0;
    display: flex;
    background: #fff;
    z-index: 1000;
  }

  /* Image Side */
  .media-side {
    flex: 1 1 55%;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  }

  .media-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .landing-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  /* Auth Side */
  .auth-side {
    flex: 1 1 45%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    background: #fff;
  }

  .auth-content {
    width: 100%;
    max-width: 380px;
  }

  .brand {
    text-align: center;
    margin-bottom: 2rem;
  }

  .brand h1 {
    font-size: 2rem;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 0.5rem;
    letter-spacing: -0.02em;
  }

  .brand p {
    font-size: 0.95rem;
    color: #666;
    margin: 0;
  }

  .demo-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    padding: 0.9rem 1.5rem;
    background: #1a1a1a;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
  }

  .demo-btn:hover:not(:disabled) {
    background: #333;
    transform: translateY(-1px);
  }

  .demo-btn:disabled {
    opacity: 0.7;
    cursor: wait;
  }

  .demo-btn svg {
    width: 20px;
    height: 20px;
  }

  .spinner {
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255,255,255,0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  .divider {
    display: flex;
    align-items: center;
    margin: 1.5rem 0;
    gap: 1rem;
  }

  .divider::before,
  .divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e5e5e5;
  }

  .divider span {
    font-size: 0.8rem;
    color: #999;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .toggle {
    width: 100%;
    margin-top: 1.25rem;
    padding: 0.75rem;
    background: none;
    border: none;
    color: #3498db;
    font-size: 0.95rem;
    cursor: pointer;
    transition: color 0.2s;
  }

  .toggle:hover {
    color: #2980b9;
    text-decoration: underline;
  }

  .terms {
    margin-top: 1.5rem;
    text-align: center;
    font-size: 0.8rem;
    color: #999;
  }

  /* Mobile */
  @media (max-width: 800px) {
    .auth-layout {
      flex-direction: column;
    }

    .media-side {
      display: none;
    }

    .auth-side {
      flex: 1;
      padding: 2rem 1.5rem;
    }
  }
</style>
